// Foil printings the game grants but the upstream catalog has no foil of.
//
// Only the four Gothic precon avatars. Their alt illustration ships Standard-
// only upstream, while the progression precons they head hand their avatar
// over foiled (see resolveStarterDeck in utils/arena/starterDecks.js), so the
// alt art needs a foil printing to be grantable and to get its own deck-
// builder tile.
//
// Keyed standard slug -> foil slug. artworkBase() strips the finish suffix, so
// the synthetic foil lands in the same alt-art group as its standard sibling
// with no change to the generated membership map.
//
// The art at the foil slug in R2 is the standard art re-uploaded under the
// foil key (scripts/upload-cards-to-r2.js resolves the source through
// SYNTHETIC_FOIL_SOURCE); the shine is the shader's, sampling the foil map
// baked from the same source (scripts/generate-foil-maps.js).
export const SYNTHETIC_FOIL_SLUGS = {
  'got-savior-pd-s': 'got-savior-pd-f',
  'got-harbinger-pd-s': 'got-harbinger-pd-f',
  'got-persecutor-pd-s': 'got-persecutor-pd-f',
  'got-necromancer-pd-s': 'got-necromancer-pd-f',
};

// Foil slug -> the upstream standard slug its art is copied from.
export const SYNTHETIC_FOIL_SOURCE = Object.fromEntries(
  Object.entries(SYNTHETIC_FOIL_SLUGS).map(([standard, foil]) => [foil, standard]),
);
